import styled from 'styled-components';
import { siteContainer } from '@luigiclaudio/ga-baseline-ui/layout';

const BrandSearchListContentContainer = styled.div`
    ${siteContainer}
    position: relative;
`;

export default BrandSearchListContentContainer;
